import { getSearch, requestCreate, requestDelete, requestUpdate, sendRequest } from "../api"
import { ADD_IN_LIST, REMOVE_IN_LIST, RESET_FORM, RESET_SEARCH_PARAMS, RESET_STATE, SET_FORM, SET_LIST, SET_OPTION, UPDATE_IN_LIST } from "../constant-types"
import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
    return {
        options : [],
        form : getDefaultFormState(),
        list : null,
        search_params : getDefaultSearchParamsState()
    }
}

const getDefaultFormState = () => {
    return {
        id : '',
        name: ''
    }
}

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text : '',
        loading : false,
        filter_sort : [{
            column : 'name',
            sort : 'asc',
            icon : ['fas', 'angle-up']
        }],
        filter_page : 1,
        filter_limit : 10
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [SET_OPTION](state, payload) {
            state.options = payload
        },
        [ADD_IN_LIST](state, newUnit) {
            state.list.data.unshift(newUnit)
        },
        [SET_FORM](state, payload) {
            Object.assign(state.form, payload)
        },
        [SET_LIST](state, payload) {
            state.list = payload
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState()
        },
        [RESET_SEARCH_PARAMS](state) {
            state.search_params = getDefaultSearchParamsState()
        },
        [REMOVE_IN_LIST](state, unit) {
            let idx = state.list.data.findIndex(l => l.id == unit.id);
            state.list.data.splice(idx, 1);
        },
        [UPDATE_IN_LIST](state, unit) {
            let idx = state.list.data.findIndex(l => l.id == unit.id);
            state.list.data[idx] = unit;
        },
        updateField

    },
    // can async
    actions: {
        loadOption({commit}) {
            return sendRequest('unit/option', {}, 'get', (successResponse) => commit(SET_OPTION, successResponse), () => {}, () => {})
        },
        loadList({commit, state, getters}, payload = { resetPage : false}) {
            if (payload.resetPage) {
                commit('updateField', { path : 'search_params.filter_page', value : 1})
            }
            return getSearch(
                {words: _.split(state.search_params.filter_search_text, ' '), fields : ['name']},
                [],
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                [],
                [],
                'unit',
                (response) => commit(SET_LIST, response),
                ()=>{},
                ()=>{}
            )
        },
        requestCreateUnit({state, commit}) {
            requestCreate('unit', state.form, commit)
        },
        requestUpdateUnit({state, commit}) {
            requestUpdate('unit', state.form, commit)
        },
        requestDeleteUnit({commit}, unit) {
            requestDelete('unit/'+unit.id, {}, commit, unit.name)
        },
        
    },
    // call variable with custom display
    getters: {
        unitName : state => unitId => {
            let found = state.options.find(o => o.id == unitId);

            return found ? found.name : '---'
        },
        getField
    }
})
